import { staticFileState } from './static-file.state';
import { staticFileGetters } from './static-file.getters';
import { staticFileActions } from './static-file.actions';
import { staticFileMutations } from './static-file.mutations';
import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { StaticApiState } from './types/static-file.types';

export default {
  namespaced: true,
  state: staticFileState,
  getters: staticFileGetters,
  actions: staticFileActions,
  mutations: staticFileMutations,
} as Module<StaticApiState, RootState>;
